import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import QuoteSOVButton from './quoteSOVButtons';

import {
  DueMonthlyWrapper,
  DueNowText,
  Amount,
  Title,
  ButtonsWrapper
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Mobile = ({
  isSendToSRT,
  isVBP,
  isFormTouched,
  isFormValidated,
  isOrderFulfillmentTeam,
  isSalesSupport,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  onSendToSRT,
  onSubmitForApproval,
  hidePricing,
  isQuoteApproved,
  isSubmitting
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      DUE_MONTHLY,
      DUE_NOW,
      BEFORE_TAXES,
      DOWNLOAD_THE_QUOTE,
      PROCEED_WITH_THE_ORDER,
      saveAndContinueLater,
      sendToSRT,
      submitForApproval,
      continueButton
    }
  } = localizedStrings;
  return (
    <div id="footer-low">
      {!hidePricing && (
        <>
          <DueMonthlyWrapper>
            <DueNowText>
              <span className="frg-body-font-14px color-white">
                {DUE_MONTHLY}
              </span>
              <Title>{BEFORE_TAXES}</Title>
              <span className="frg-body-font-14px color-white">{DUE_NOW}</span>
              <Title>{BEFORE_TAXES}</Title>
            </DueNowText>

            <Amount>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-monthly-total-low">{dueMonthly}</div>
              </span>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-now-total-low">{dueNow}</div>
              </span>
            </Amount>
          </DueMonthlyWrapper>
        </>
      )}

      {isOrderFulfillmentTeam ? (
        <QuoteSOVButton
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          onDownloadClick={onDownloadClick}
          onProceedClick={onProceedClick}
          onValidateForm={onValidateForm}
          isSubmitting={isSubmitting}
        />
      ) : (
        <ButtonsWrapper style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          {isFormValidated && !isVBP && (
            <Button
              type="button"
              onClick={e => onDownloadClick(e)}
              variant={{ priority: 'high' }}
            >
              {DOWNLOAD_THE_QUOTE}
            </Button>
          )}
          {!isSendToSRT && !isVBP && isFormValidated && (
            <Button
              type="button"
              onClick={e => onProceedClick(e)}
              variant={{ priority: 'high' }}
              disabled={isSubmitting}
            >
              {PROCEED_WITH_THE_ORDER}
            </Button>
          )}
          {isSendToSRT && !isVBP && isFormValidated && (
            <Button
              type="button"
              onClick={e => onSendToSRT(e)}
              variant={{ priority: 'high' }}
              disabled={isSubmitting}
            >
              {sendToSRT}
            </Button>
          )}
          {!isFormValidated && !isVBP && (
            <Button
              type="button"
              onClick={e => onSaveAndExit(e)}
              variant={{ priority: 'low' }}
              disabled={!isFormTouched && !isQuoteApproved}
            >
              {saveAndContinueLater}
            </Button>
          )}
          {!isFormValidated && !isVBP && (
            <Button
              type="button"
              onClick={e => onValidateForm(e)}
              variant={{ priority: 'high' }}
              disabled={isSubmitting || (!isFormTouched && !isQuoteApproved)}
            >
              {continueButton}
            </Button>
          )}
          {isFormValidated && isVBP && !isSalesSupport && (
            <Button
              type="button"
              onClick={e => onSubmitForApproval(e)}
              variant={{ priority: 'high' }}
              disabled={isSubmitting}
            >
              {submitForApproval}
            </Button>
          )}
        </ButtonsWrapper>
      )}
    </div>
  );
};

Mobile.propTypes = {
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  isSendToSRT: PropTypes.bool.isRequired,
  isVBP: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  onSendToSRT: PropTypes.func.isRequired,
  onSubmitForApproval: PropTypes.func.isRequired,
  isQuoteApproved: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool
};

export default Mobile;
